import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { slugify } from "helpers";
import HTMLEllipsis from "react-lines-ellipsis/lib/html";
import Bundle from "components/Bundle";
import PartnerLinkImage from "./partnerLinkImage";

const SearchResultProductInfo = ({
  ceCredits,
  productName,
  sku,
  courseBundleCount,
  shortDescription,
  partnerName,
  partnerNameSEO,
  partnerImage
}) => {
  return (
    <>
      <div className="products__result-info">
        {ceCredits > 0 && (
          <div className="products__result-credit">
            <span>CE</span>
          </div>
        )}
        <div className="products__result-name">
          <Link to={`/products/${slugify(productName)}-${sku}`}>
            {productName}
          </Link>
        </div>
        <div className="products__result-meta">
          <Bundle
            bundleCount={courseBundleCount}
            className="products__result-bundle"
          />
        </div>
        <div className="products__result-description">
          <HTMLEllipsis
            unsafeHTML={shortDescription}
            maxLine="2"
            ellipsis="..."
            basedOn="letters"
          />
        </div>
        {partnerName && (
          <div className="products__result-partner">
            <span>Content provided by: </span>
            <PartnerLinkImage
              nameSEO={partnerNameSEO}
              partnerImage={partnerImage}
              partnerName={partnerName}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default SearchResultProductInfo;

SearchResultProductInfo.propTypes = {
  ceCredits: PropTypes.number,
  productName: PropTypes.string,
  sku: PropTypes.string,
  courseBundleCount: PropTypes.number,
  shortDescription: PropTypes.string,
  partnerName: PropTypes.string,
  partnerNameSEO: PropTypes.string,
  partnerImage: PropTypes.string
};

SearchResultProductInfo.defaultProps = {
  ceCredits: null,
  productName: undefined,
  sku: undefined,
  courseBundleCount: null,
  shortDescription: undefined,
  partnerName: undefined,
  partnerNameSEO: undefined,
  partnerImage: undefined
};
